import React from 'react'
import UpdateAnimal from '../components/UpdateAnimal'

const AnimalUpdate = () => {
  return (
    <div>
        <UpdateAnimal/>
    </div>
  )
}

export default AnimalUpdate